import Vue from "vue";
import LoadingComponent from "./index.vue";

const LoadingConstructor = Vue.extend(LoadingComponent);

let instance = null;

/**
 * 显示Loading
 * @param {Object} options - 配置选项
 * @param {Boolean} options.fullScreen - 是否全屏显示，默认true
 * @param {String} options.background - 背景色，默认'rgba(0, 0, 0, 0.3)'
 */
function showLoading(options = {}) {
  // 如果已经有实例存在，则先隐藏
  if (instance) {
    hideLoading();
  }

  // 默认配置
  const config = {
    fullScreen: true,
    ...options
  };

  // 创建新实例
  instance = new LoadingConstructor({
    propsData: {
      fullScreen: config.fullScreen,
    }
  });

  // 挂载到DOM
  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);

  return instance;
}

/**
 * 隐藏Loading
 */
function hideLoading() {
  if (instance && instance.$el) {
    try {
      // 移除DOM元素
      if (instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el);
      }
      // 销毁实例
      instance.$destroy();
      instance = null;
    } catch (error) {
      console.warn('Loading hide error:', error);
      instance = null;
    }
  }
}

/**
 * 检查Loading是否正在显示
 * @returns {Boolean}
 */
function isLoading() {
  return !!instance;
}

// 导出对象
const Loading = {
  show: showLoading,
  hide: hideLoading,
  isLoading: isLoading,
  
  // Vue插件安装方法
  install(Vue) {
    Vue.prototype.$loading = {
      show: showLoading,
      hide: hideLoading,
      isLoading: isLoading
    };
  }
};

export default Loading;